import {svgIconWrapper} from '../svg-icon-wrapper';

import PipelineRegular from './pipeline-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <PipelineRegular {...props} />;
}
SvgComponent.iconName = 'pipelineRegular';

export const PipelineRegularIcon = svgIconWrapper(SvgComponent);
